import React from 'react';

const CustomTooltip = ({ active, payload, label, showname, float }) => {

  if (active && payload && payload.length) {
    const maxHeight = '30px';
    return (
      <div style={{...tooltipContainerStyle, maxHeight}}>
        <div style={tooltipContentStyle}>
          {payload.map((entry, index) => (
            <div key={`item-${index}`} style={tooltipItemStyle}>
              {showname !== 0 && `${entry.name}: `}
              <span style={tooltipValueStyle}>
                {float === 0 ? Math.floor(entry.value) : entry.value.toFixed(3)}
              </span>
          </div>
          ))}
        </div>
      </div>
    );
  }
  return null;
};

const tooltipContainerStyle = {
  backgroundColor: 'rgba(145, 145, 145, 0.5)',
  // padding: '3px',
  borderRadius: '5px',
  border: '1px solid #ccc',
  maxHeight: '30px', // Set a maximum height
  overflowY: 'hidden', 
};

const tooltipContentStyle = {
  maxHeight: '30px', // Limit the content height
  overflow: 'hidden', // Hide overflow content
};

const tooltipItemStyle = {
  color: '#000',
};

const tooltipValueStyle = {
  textAlign: 'center', // Center the text horizontally
  flex: 1, // Allow the value to take available space
};
export default CustomTooltip;
